// src/screens/Admin/GraphsManager.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GraphsManager.css';

import backIcon from '../../assets/backspace-icon.png';
import rightIcon from '../../assets/dropdown-icon.png'; // reuse as arrow

function GraphsManager() {
  const navigate = useNavigate();

  return (
    <div className="graphs-container">
      <div className="graphs-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="back-arrow"
          onClick={() => navigate('/admin')}
        />
        <span className="graphs-title">Graphs</span>
      </div>

      <div className="graphs-tiles">
        {/* Tile 1: Existing line-graphs detail screen */}
        <button
          type="button"
          className="graphs-tile"
          onClick={() => navigate('/admin/graphs/detail')}
        >
          <div className="graphs-tile-left">
            <div className="graphs-tile-title">Detailed Graphs</div>
            <div className="graphs-tile-sub">
              Signups • DAU • WAU • Stickiness
            </div>
          </div>

          <img src={rightIcon} alt="" className="graphs-tile-arrow" />
        </button>

        {/* Tile 2: Engagement line graphs */}
        <button
          type="button"
          className="graphs-tile"
          onClick={() => navigate('/admin/graphs/engagement')}
        >
          <div className="graphs-tile-left">
            <div className="graphs-tile-title">Engagement Graphs</div>
            <div className="graphs-tile-sub">
              Avg Likes/Post • Avg Comments/Post • Density
            </div>
          </div>

          <img src={rightIcon} alt="" className="graphs-tile-arrow" />
        </button>

        {/* Tile 3: New hourly bucket bar chart screen */}
        <button
          type="button"
          className="graphs-tile"
          onClick={() => navigate('/admin/graphs/activity')}
        >
          <div className="graphs-tile-left">
            <div className="graphs-tile-title">Activity by Time of Day</div>
            <div className="graphs-tile-sub">
              00–04 • 04–08 • 08–12 • 12–16 • 16–20 • 20–24
            </div>
          </div>

          <img src={rightIcon} alt="" className="graphs-tile-arrow" />
        </button>
      </div>
    </div>
  );
}

export default GraphsManager;
